export const ACTION_TYPE = {
	GET_VIDEOS: "GET_VIDEOS",
	ADD_TO_LIKE: "ADD_TO_LIKE",
	REMOVE_FROM_LIKE: "REMOVE_FROM_LIKE",
	GET_LIKED_VIDEOS: "GET_LIKED_VIDEOS",
	GET_PLAYLIST: "GET_PLAYLIST",
	CREATE_PLAYLIST: "CREATE_PLAYLIST",
	DELETE_PLAYLIST: "DELETE_PLAYLIST",
	SHOW_MODAL: "SHOW_MODAL",
	HIDE_MODAL: "HIDE_MODAL",
	GET_PLAYLIST_VIDEOS: "GET_PLAYLIST_VIDEOS",
	ADD_TO_PLAYLIST: "ADD_TO_PLAYLIST",
	REMOVE_FROM_PLAYLIST: "REMOVE_FROM_PLAYLIST",
	GET_WATCH_LATER_VIDEOS: "GET_WATCH_LATER_VIDEOS",
	ADD_TO_WATCH_LATER: "ADD_TO_WATCH_LATER",
	REMOVE_FROM_WATCH_LATER: "REMOVE_FROM_WATCH_LATER",
	ADD_TO_HISTORY: "ADD_TO_HISTORY",
	REMOVE_FROM_HISTORY: "REMOVE_FROM_HISTORY",
	GET_HISTORY_VIDEOS: "GET_HISTORY_VIDEOS",
	CLEAR_ALL_HISTORY: "CLEAR_ALL_HISTORY",
};
